import React from 'react'
import PropTypes from 'prop-types'
import { LayoutType } from './layoutTypes'

const SideNav = ({ children }) => <>{children}</>
const Header = ({ children }) => <>{children}</>
const Main = ({ children }) => <>{children}</>
const Footer = ({ children }) => <>{children}</>

export const Layout = ({ children, type = LayoutType.Default }) => {
  const sideNav = React.Children.toArray(children).find(c => c.type === SideNav)
  const header = React.Children.toArray(children).find(c => c.type === Header)
  const main = React.Children.toArray(children).find(c => c.type === Main)
  const footer = React.Children.toArray(children).find(c => c.type === Footer)

  if (type === LayoutType.Login) {
    return <>{children}</>
  }

  return (
    <div className="flex relative max-w-[120rem] min-h-screen mx-auto bg-grey-98">
      {sideNav && (
        <aside className="fixed hidden tablet-p:block top-0 w-60 h-screen overflow-y-auto bg-white shadow-[1px_0_0_var(--color-grey-90)]">
          {sideNav}
        </aside>
      )}
      <div className="flex flex-col w-full tablet-p:w-[calc(100%-15rem)] tablet-p:ml-60">
        {header && (
          <header className="sticky top-0 z-[1] border-b border-grey-90 bg-white">{header}</header>
        )}
        {main && <main className="flex-1 m-6 max-tablet-p:m-4 desktop:m-8">{main}</main>}
        {footer && <footer className="sticky bottom-0">{footer}</footer>}
      </div>
    </div>
  )
}

const childrenProp = { children: PropTypes.node.isRequired }
SideNav.propTypes = childrenProp
Header.propTypes = childrenProp
Main.propTypes = childrenProp
Footer.propTypes = childrenProp
Layout.propTypes = { children: PropTypes.node.isRequired, type: PropTypes.string }

Layout.SideNav = SideNav
Layout.Header = Header
Layout.Main = Main
Layout.Footer = Footer
